import { Injectable } from '@angular/core';
import { Constants } from './../../app.constants';

@Injectable({
    providedIn: 'root',
})
export class DebugService {
    debugMode = 0;
    constructor(private constants: Constants) {
        this.debugMode = this.constants.debugMode;
    }

    output(componentName: string, obj: string, msg: any) {
        if (this.debugMode == 1) {
            console.log(`DEBUG::OUTPUT ${componentName} - ${obj}:`, msg);
        }
    }

    simpleStringify(object) {
        var simpleObject = {};
        for (var prop in object) {
            if (!object.hasOwnProperty(prop)) {
                continue;
            }
            if (typeof object[prop] == 'object') {
                continue;
            }
            if (typeof object[prop] == 'function') {
                continue;
            }
            simpleObject[prop] = object[prop];
        }
        return JSON.stringify(simpleObject);
    }
}
